export default {
  methods: {
    state (field) {
      if (!this.veeFields[field]) return null
      return this.veeFields[field].pristine && !this.veeFields[field].validated
        ? null
        : !this.veeErrors.has(field)
    }
  }
}
